/**
 * ? Signup Form Component
 */

// Dependencies
import React, { Fragment, useEffect, useState } from "react";
// import { Navbar } from "react-bootstrap";
import {
  Box,
  Typography,
  TextField,
  Button,
  InputAdornment,
  IconButton,
  Tooltip,
  MenuItem,
  Stack,
  Modal,
} from "@mui/material";
import { useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";

// Assets
// import ltelogo from "./../../assets/logov1.svg";

// MUI Icons
import { VisibilityOff, Visibility, Close } from "@mui/icons-material";

// Axios Component
import Axios from "../../axios/Axios";

// Redux Component
import { showSnackbar } from "../redux/features/appSlice";
import { LoadingButton } from "@mui/lab";

function SignupForm() {
  // * Redux Variable
  const dispatch = useDispatch();

  // * Router Variable
  // const navigate = useNavigate();

  // * Local Storage Variable
  const username = sessionStorage.getItem("username");

  // * State Variables
  const [signupData, setSignupData] = useState({
    firstName: "",
    lastName: "",
    userName: "",
    phoneNumber: "",
    email: "",
    role: "",
    // password: "",
    // confirmPassword: "",
    showPassword: false,
  });
  const [statusAlert, setStatusAlert] = useState(false);
  const [firstNameError, setFirstNameError] = useState({
    error: false,
    message: "",
  });
  const [lastNameError, setLastNameError] = useState({
    error: false,
    message: "",
  });
  const [userNameError, setUserNameError] = useState({
    error: false,
    message: "",
  });
  const [phoneNumberError, setPhoneNumberError] = useState({
    error: false,
    message: "",
  });
  const [emailError, setEmailError] = useState({
    error: false,
    message: "",
  });
  const [roleError, setRoleError] = useState({
    error: false,
    message: "",
  });
  const [passwordError, setPasswordError] = useState({
    error: false,
    message: "",
  });
  const [confirmPasswordError, setConfirmPasswordError] = useState({
    error: false,
    message: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);


  const styleBox = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 2,
    borderRadius: "8px"
  }
  
  // useEffect (()=>{

  //   if(showPassword === false){
  //     setSignupData({
  //       firstName: "",
  //       lastName: "",
  //       userName: "",
  //       phoneNumber: "",
  //       email: "",
  //       role: "",
  //       // password: "",
  //       // confirmPassword: "",
  //       showPassword: false,
  //     })
  //   }
  // },[showPassword])

  // TODO : Check Email
  function checkMail(email) {
    let pattern = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );
    let result = pattern.test(email);
    return !result;
  }

  // TODO : Mobile number Validation Pattern
  const checkInvalidNumber = (number) => {
    var pattern = new RegExp(
      /^(?:(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[6789]\d{9})$/
    );
    var result = pattern.test(number);
    return !result;
  }

  // TODO : Form Data Validation
  function checkFormData() {
    let isFormDataValid = true;

    if (signupData.firstName.length === 0
      // || signupData.firstName.length > 20
    ) {
      isFormDataValid = false;
      setFirstNameError({
        ...firstNameError,
        error: true,
        message: "First name is required"
        //  and characters must be less than 20.",
      });
    }
    // else if(!(/^[a-zA-Z]{2,20}$/.test(signupData.firstName))) {
    //   isFormDataValid = false;
    //   setFirstNameError({
    //     ...firstNameError,
    //     error: true,
    //     message: "First name is not valid.",
    //   });
    // }

    if (signupData.lastName.length === 0
      //  || signupData.lastName.length > 20
    ) {
      isFormDataValid = false;
      setLastNameError({
        ...lastNameError,
        error: true,
        message: "Last name is required"
        // and characters must be less than 20.",
      });
    }
    // else if(!(/^[a-zA-Z]{1,20}$/.test(signupData.lastName))) {
    //   isFormDataValid = false;
    //   setLastNameError({
    //     ...lastNameError,
    //     error: true,
    //     message: "Last name is not valid.",
    //   });
    // }

    if (signupData.userName.length === 0
      // || signupData.userName.length > 20 
    ) {
      isFormDataValid = false;
      setUserNameError({
        ...userNameError,
        error: true,
        message: "User name is required"
        // "Username should not include any space and the character must be alphanumerics and less than 20 characters.",
      });
    } else if( !(/^[a-zA-Z_]+$/ig.test(signupData.userName))){
      isFormDataValid = false;
      setUserNameError({
        ...userNameError,
        error: true,
        message: "User name is not valid"
      });
    }

    if (!(signupData.phoneNumber.length === 10)) {
      isFormDataValid = false;
      setPhoneNumberError({
        ...phoneNumberError,
        error: true,
        message:
          "Phone number is required and must be a valid 10 digits number.",
      });
    }
    // else {
    //   if(checkInvalidNumber(signupData.phoneNumber)){
    //     isFormDataValid = false;
    //     setPhoneNumberError({
    //       ...phoneNumberError,
    //       error: true,
    //       message:
    //         "Phone number is Invalid.",
    //     });
    //   }
    // }

    if (signupData.email.length === 0) {
      isFormDataValid = false;
      setEmailError({
        ...emailError,
        error: true,
        message: "Email Id is required.",
      });
    }
    // else {
    //   if (checkMail(signupData.email)) {
    //     isFormDataValid = false;
    //     setEmailError({
    //       ...emailError,
    //       error: true,
    //       message: "Enter valid email id.",
    //     });
    //   }
    // }

    if (signupData.role.length === 0) {
      isFormDataValid = false;
      setRoleError({
        ...roleError,
        error: true,
        message: "Role is required and please select any one.",
      });
    }

    // if (signupData.password.length === 0 || signupData.password.length > 10) {
    //   isFormDataValid = false;
    //   setPasswordError({
    //     ...passwordError,
    //     error: true,
    //     message: "Password is required and characters must be less than 10.",
    //   });
    // }

    // if (signupData.password !== signupData.confirmPassword) {
    //   isFormDataValid = false;
    //   setConfirmPasswordError({
    //     ...confirmPasswordError,
    //     error: true,
    //     message: "Password do not match.",
    //   });
    // }

    return isFormDataValid;
  }

  // ? API Call : Post Method : Submit All the Data to the Server
  async function postSignupData() {
    try {

      const validated_Data = checkFormData();

      if (validated_Data) {
        setLoading(true);
        const finalData = {
          first_name: signupData.firstName,
          last_name: signupData.lastName,
          username: signupData.userName,
          phone_no: signupData.phoneNumber,
          email_id: signupData.email.toLowerCase(),
          role: signupData.role,
          // password: signupData.password,
          // confirmPassword: signupData.confirmPassword,
          created_by: username,
        };

        const options = {
          method: "post",
          url: "/adminlogin/add",
          auth: true,
          data: finalData,
        };

        const response = await Axios(
          options.method,
          options.url,
          options.auth,
          options.data
        );
        if (response.status === 200) {
          // console.log(response.data);
          setLoading(false);
          dispatch(
            showSnackbar({
              message: response.data,
              severity: "error",
            })
          );
        } else if (response.status === 201) {
          // navigate("/login");
          // window.location.reload();
          // console.log(response);
          // setSignupData({
          //   firstName: "",
          //   lastName: "",
          //   userName: "",
          //   phoneNumber: "",
          //   email: "",
          //   role: "",
          //   // password: "",
          //   // confirmPassword: "",
          //   showPassword: false,
          // })
          setLoading(false);
          setStatusAlert(true);
          // dispatch(
          //   showSnackbar({
          //     message: response.data.message,
          //     severity: "success",
          //   })
          // );
        }
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
      dispatch(
        showSnackbar({
          message: "Error occured while creating an admin/spoc",
          severity: "error",
        })
      );
    }
  }

  // * Show Password Function
  function handleClickShowPassword() {
    setShowPassword(!showPassword);
  }

  // * Show Password Function
  function handleMouseDownPassword(event) {
    event.preventDefault();
    setShowPassword(!showPassword);
  }

  // * Show Success popup function
  function SuccessPopUp({ open, onClose,signupData, setSignupData }) {
const closeTab = () =>{
  setSignupData({
    firstName: "",
    lastName: "",
    userName: "",
    phoneNumber: "",
    email: "",
    role: "",
    // password: "",
    // confirmPassword: "",
    showPassword: false,
  })
  onClose()
}
    return (
      <Modal
        open={open}
        onClose={closeTab}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{ zIndex: 2000, position: 'fixed', }}
      >
        <Box sx={styleBox}>
          <Stack pb={2} direction="row" alignItems="center" justifyContent="space-between" >
            <Stack>
              <h5 style={{ color: "#ff3333" }}>
                Success!&nbsp;
              </h5>
            </Stack>
            <Box>
              <IconButton onClick={closeTab}>
                <Close />
              </IconButton>
            </Box>
          </Stack>
          <Stack>
            <p>{`${signupData.role} created successfully`}</p>
          </Stack>
        </Box>



      </Modal>
    )
  }

  return (
  <>
      <Fragment>
      {/* Navigation Bar */}
      {/* <Navbar className="login-admin">
        <Navbar.Brand href="#">
          <a class="navbar-brand" href="#">
            <img className="ltelogo" src={ltelogo} alt="Logo" />
            <span className="login-admin-title">Lets Teach English</span>
          </a>
        </Navbar.Brand>
      </Navbar> */}

      {/* Title */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="h4" component="div" sx={{ fontWeight: 200 }}>
          Signup Form
        </Typography>
      </Box>

      {/* Input Fields */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            mt: "16px",
          }}
        >
          <Typography variant="h6" component="div">
            First Name&nbsp;<span style={{ color: "red" }}>*</span>
          </Typography>

          <TextField
            type="text"
            id="firstName"
            size="small"
            variant="outlined"
            label="First Name"
            placeholder="First Name"
            sx={{ width: 500 }}
            value={signupData.firstName}
            onChange={(e) => {
              setFirstNameError({
                ...firstNameError,
                error: false,
                message: "",
              });
              setSignupData({ ...signupData, firstName: e.target.value });
            }}
            error={firstNameError.error}
            helperText={firstNameError.error ? firstNameError.message : ""}
          />
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            mt: "16px",
          }}
        >
          <Typography variant="h6" component="div">
            Last Name&nbsp;<span style={{ color: "red" }}>*</span>
          </Typography>

          <TextField
            type="text"
            id="lastName"
            size="small"
            variant="outlined"
            label="Last Name"
            placeholder="Last Name"
            sx={{ width: 500 }}
            value={signupData.lastName}
            onChange={(e) => {
              setLastNameError({
                ...lastNameError,
                error: false,
                message: "",
              });
              setSignupData({ ...signupData, lastName: e.target.value });
            }}
            error={lastNameError.error}
            helperText={lastNameError.error ? lastNameError.message : ""}
          />
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            mt: "16px",
          }}
        >
          <Typography variant="h6" component="div">
            User Name&nbsp;<span style={{ color: "red" }}>*</span>
          </Typography>

          <TextField
            type="text"
            id="admin-username"
            size="small"
            variant="outlined"
            label="User Name"
            placeholder="User Name"
            sx={{ width: 500 }}
            value={signupData.userName}
            onChange={(e) => {
              setUserNameError({
                ...userNameError,
                error: false,
                message: "",
              });
              setSignupData({ ...signupData, userName: e.target.value });
            }}
            error={userNameError.error}
            helperText={userNameError.error ? userNameError.message : ""}
            autoComplete="off"
          />
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            mt: "16px",
          }}
        >
          <Typography variant="h6" component="div">
            Phone&nbsp;Number&nbsp;<span style={{ color: "red" }}>*</span>
          </Typography>

          <TextField
            type="tel"
            id="phoneNumber"
            size="small"
            variant="outlined"
            label="Phone Number"
            placeholder="98xxxxxx10"
            sx={{ width: 500 }}
            value={signupData.phoneNumber}
            onChange={(e) => {
              setPhoneNumberError({
                ...phoneNumberError,
                error: false,
                message: "",
              });
              setSignupData({ ...signupData, phoneNumber: e.target.value });
            }}
            error={phoneNumberError.error}
            helperText={phoneNumberError.error ? phoneNumberError.message : ""}
          />
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            mt: "16px",
          }}
        >
          <Typography variant="h6" component="div">
            Email&nbsp;<span style={{ color: "red" }}>*</span>
          </Typography>
          <TextField
            type="email"
            id="email"
            size="small"
            variant="outlined"
            label="Email"
            placeholder="Email@example.com"
            sx={{ width: 500 }}
            value={signupData.email}
            onChange={(e) => {
              setEmailError({
                ...emailError,
                error: false,
                message: "",
              });
              setSignupData({ ...signupData, email: e.target.value });
            }}
            error={emailError.error}
            helperText={emailError.error ? emailError.message : ""}
          />
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            mt: "16px",
          }}
        >
          <Typography variant="h6" component="div">
            Role&nbsp;<span style={{ color: "red" }}>*</span>
          </Typography>

          <TextField
            select
            type="text"
            id="role"
            size="small"
            variant="outlined"
            label="Role"
            placeholder="Admin"
            sx={{ width: 500 }}
            value={signupData.role}
            onChange={(e) => {
              setRoleError({
                ...roleError,
                error: false,
                message: "",
              });
              setSignupData({ ...signupData, role: e.target.value });
            }}
            error={roleError.error}
            helperText={roleError.error ? roleError.message : ""}
          >
            <MenuItem value="admin">Admin</MenuItem>
            <MenuItem value="spoc">SPOC</MenuItem>
          </TextField>
        </Box>
        {/* 
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            mt: "16px",
          }}
        >
          <Box>
            <Typography variant="h6" component="div">
              Password&nbsp;<span style={{ color: "red" }}>*</span>
            </Typography>
          </Box>

          <TextField
            type={showPassword ? "text" : "password"}
            id="admin-pass"
            size="small"
            variant="outlined"
            label="Password"
            sx={{ width: 500 }}
            value={signupData.password}
            onChange={(e) => {
              setPasswordError({
                ...passwordError,
                error: false,
                message: "",
              });
              setSignupData({ ...signupData, password: e.target.value });
            }}
            error={passwordError.error}
            helperText={passwordError.error ? passwordError.message : ""}
            InputProps={{
              autoComplete: 'new-password',
              endAdornment: (
                <InputAdornment>
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                  >
                    {showPassword ? (
                      <Tooltip title="Hide Password" arrow placement="right">
                        <Visibility />
                      </Tooltip>
                    ) : (
                      <Tooltip title="Show Password" arrow placement="right">
                        <VisibilityOff />
                      </Tooltip>
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            mt: "16px",
          }}
        >
          <Typography variant="h6" component="div">
            Confirm&nbsp;Password&nbsp;<span style={{ color: "red" }}>*</span>
          </Typography>
          <TextField
            type={showConfirmPassword ? "text" : "password"}
            id="confirmPassword"
            size="small"
            variant="outlined"
            label="Confirm Password"
            placeholder="********"
            sx={{ width: 500 }}
            value={signupData.confirmPassword}
            onChange={(e) => {
              setConfirmPasswordError({
                ...confirmPasswordError,
                error: false,
                message: "",
              });
              setSignupData({ ...signupData, confirmPassword: e.target.value });
            }}
            error={confirmPasswordError.error}
            helperText={
              confirmPasswordError.error ? confirmPasswordError.message : ""
            }
            InputProps={{
              autoComplete: 'new-password',
              endAdornment: (
                <InputAdornment>
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    // onMouseDown={handleMouseDownPassword}
                  >
                    {showConfirmPassword ? (
                      <Tooltip title="Hide Password" arrow placement="right">
                        <Visibility />
                      </Tooltip>
                    ) : (
                      <Tooltip title="Show Password" arrow placement="right">
                        <VisibilityOff />
                      </Tooltip>
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            
          />
        </Box> */}

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            mt: "16px",
            mb: "32px",
          }}
        >
          <Button
            type="reset"
            variant="contained"
            color="inherit"
            sx={{ width: 100, mr: "16px" }}
            onClick={() => {
              setSignupData({
                ...signupData,
                firstName: "",
                lastName: "",
                userName: "",
                phoneNumber: "",
                email: "",
                role: "",
                password: "",
                confirmPassword: "",
              });
              window.location.reload();
            }}
          >
            Reset
          </Button>

          {/* <LoadingButton
            size="small"
            onClick={handleClick}
            loading={loading}
            variant="contained"
        >
          Send
        </LoadingButton> */}

          <LoadingButton
            type="submit"
            variant="contained"
            loading={loading}
            color="primary"
            sx={{ width: 100, backgroundColor: "#1D3FAA", color: "#fff" }}
            onClick={postSignupData}
          >
            Submit
          </LoadingButton>

        </Box>
      </Box>
    </Fragment>
    <SuccessPopUp
        open={statusAlert}
        onClose={() => setStatusAlert(false)}
        signupData = {signupData}
        setSignupData ={setSignupData}
      />
  </>

  );
}

export default SignupForm;
